import { install } from '@material-ui/styles'

install()
